import { useState, useEffect } from "react";
import { useLanguage } from "../../../../hooks/useLanguage";

const CountdownTimer = ({ expiryTime }) => {
  const t = useLanguage();
  const [timeLeft, setTimeLeft] = useState("");
  const [percentageLeft, setPercentageLeft] = useState(100);

  useEffect(() => {
    if (!expiryTime) return;

    const updateCountdown = () => {
      const now = new Date();
      const expiry = new Date(expiryTime);
      const diff = expiry - now;

      if (diff <= 0) {
        setTimeLeft("0d 0h 0m 0s"); // Timer expired
        setPercentageLeft(0);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);

      // Calculate percentage left
      const startTime = new Date(expiryTime);
      startTime.setDate(startTime.getDate() - 7); // 7 days before expiry time
      const totalDuration = expiry - startTime;
      const percentage = (diff / totalDuration) * 100;

      setPercentageLeft(percentage.toFixed(2));
    };

    updateCountdown(); // Initial call
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [expiryTime]);

  return (
    <div
      className={` position-relative  text-center rounded-pill mt-2`}
      style={{ background: "#242434", fontSize: 10, lineHeight: "16px" }}
    >
      <div
        className="position-absolute h-100 rounded-pill"
        style={{
          zIndex: -1,
          top: 0,
          left: 0,
          width: `calc(100% - ${percentageLeft}%)`,
          background: "#54B3F5",
        }}
      ></div>
      <div className=" fw-bold" style={{ color: "#ABABB1" }}>
        {" "}
        <span className=" fw-normal">
          {" "}
          {t("wallet_page.cryptohistory_tab.ends_in")}
        </span>
        {timeLeft}
      </div>
    </div>
  );
};

export default CountdownTimer;
